import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CodeInputField } from "../../core/components/input/CodeInputField";
import { InfoText } from "../../core/components/texts/InfoText";
import { useHandleAppointmentBookingNavigation } from "../navigation/utils/useHandleAppointmentBookingNavigation";
import { AppointmentScreenWrapper } from "../onboarding/AppointmentScreenWrapper";

export const AppointmentPhoneVerificationScreen = () => {
  const { t } = useTranslation();
  const navigate = useHandleAppointmentBookingNavigation();

  const [code, setCode] = useState("");
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (code.length === 6) {
      // Simulate code verification
      const isCodeValid = code === "123456"; // Replace with real verification logic
      if (isCodeValid) {
        navigate();
      } else {
        setError(t("APPOINTMENT_PHONE_VERIFICATION_INVALID_CODE_ERROR"));
      }
    }
  }, [code, navigate, t]);

  return (
    <AppointmentScreenWrapper>
      <InfoText
        headline={t("APPOINTMENT_PHONE_NUMBER_SCREEN_TITLE")}
        text={[t("APPOINTMENT_PHONE_NUMBER_SCREEN_DESCRIPTION")]}
      />
      <CodeInputField
        code={code}
        setCode={setCode}
        handleResendCode={() => {
          setCode("");
          setError(undefined);
        }}
        error={error}
      />
    </AppointmentScreenWrapper>
  );
};
